<template>
  <div class="com-box">
    <div class="title-box">
      <div class="title">全友家居</div>
      <div class="title-center">
        <img src="@/assets/icons/icon-ys@2x.png" alt="" />
        <p class="title conter-p">{{ activityData.activityTitle }}</p>
        <img src="@/assets/icons/icon-ys@2x.png" alt="" />
      </div>
    </div>
    <div class="sign-box">
      <div class="sign-content">
        <div class="countdown-box">
          <div class="countdown-box-title">
            <van-icon name="clock-o" size="18" />
            <span>距离活动结束</span>
          </div>
          <van-count-down :time="countDownTime">
            <template #default="timeData">
              <div class="countdown-content">
                <span class="block">{{ timeData.days }}</span>
                <span class="space">天</span>
                <span class="block">{{ timeData.hours }}</span>
                <span class="space">时</span>
                <span class="block">{{ timeData.minutes }}</span>
                <span class="space">分</span>
                <span class="block">{{ timeData.seconds }}</span>
                <span class="space">秒</span>
              </div>
            </template>
          </van-count-down>
        </div>
        <div class="fee-box">
          <template v-if="+activityData.signUpfee > 0">
            <div class="fee-title">
              <img src="@/assets/icons/check@2x.png" alt="" />
              <span class="fee-text">{{activityData.signUpfeeLabel}}</span>
            </div>
            <div class="fen-money">
              <span class="fee-num">
                <span class="fee-fu">￥</span>
                <span :style="{fontSize: (activityData.signUpfee.toString().length >= 6 ? '49px' : '')}">{{activityData.signUpfee || 0}}</span>
              </span>
            </div>
          </template>
          <span v-else class="fee-free">免费</span>
          <div class="btn-box">{{joinBtnText}}</div>
        </div>

        <div class="num-box">
          <div class="num-box-left">
            <img src="@/assets/icons/icon-yll.png" alt="" />
            <p>已浏览<span>{{signUpData.browsePeopleNumber}}</span>人</p>
          </div>
          <img src="@/assets/images/img-tx1.png" alt="" />
        </div>
        <div class="num-box num-border">
          <div class="num-box-left">
            <img src="@/assets/icons/icon-ycj.png" alt="" />
            <p>已参与<span>{{signUpData.signUpNumber}}</span>人</p>
          </div>
          <img src="@/assets/images/img-tx2.png" alt="" />
        </div>

        <div class="notice-box" v-if="activityData.boolShowNotice">
          <van-notice-bar left-icon="volume-o" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="3000"
              :show-indicators="false"
            >
              <van-swipe-item v-for="item in signUpData.signUpList" :key="item.userPhone">
                刚刚{{item.joinUserName | joinUserName }}已成功参与活动
              </van-swipe-item>
            </van-swipe>
          </van-notice-bar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import signUpMixin from './signUpMixin'
export default {
 mixins: [signUpMixin]
}
</script>

<style lang="stylus" scoped>
.com-box {
  overflow: hidden;
  .title-box {
    margin-top: 32px;
    .title {
      font-size: 22px;
      font-weight: 600;
      color: #fff;
      text-align: center;
      margin-bottom: 4px
    }
    .title-center {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 34px;
      img {
        width: 22px;
        height: 22px;
      }
      .conter-p {
        font-size: 22px;
        margin: 0 5px;
      }
    }
  }
  .sign-box {
    margin-top: 20px;
    .sign-content {
      .countdown-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        .countdown-box-title {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 14px;
          font-weight: 400;
          span {
            margin-left: 5px;
          }
        }
        .countdown-content {
          margin-top: 10px;
          .block {
            display: inline-block;
            width: 34px;
            height: 31px;
            color: #ffffff;
            text-align: center;
            line-height: 31px;
            font-weight: 600;
            font-size: 21px;
            border: 1px dashed;
            border-color: rgba(255,255,255,0.2);
          }
          .space {
            color: #fff;
            font-size: 12px;
            margin: 0 3px;
            margin-top: 7px;
          }
        }
      }
      .fee-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        width:  100%;
        height: 342px;
        background: url('~@/assets/images/packet@2x.png');
        background-size: 100% 100%;
        .fee-title {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 65px;
          img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
          color: #FFB7A7;
          font-size: 16px;
        }
        .fen-money {
          width: 240px;
          height: 100px;
          line-height: 100px;
          text-align: center;
          color: #FE493B;
          .fee-num {
            font-size: 80px;
            font-weight: 600;
            .fee-fu {
              font-size: 25px;
            }
          }
        }
        .fee-free {
          color: #FE493B;
          font-size: 87px;
          font-weight: 600;
          margin-top: 75px;
        }
        .btn-box {
          width: 224px;
          height: 65px;
          color: #ED3C2A;
          font-size: 16px;
          text-align: center;
          line-height: 46px;
          margin-top: 68px;
          font-weight: bold;
          background: url('~@/assets/images/buteen@2x.png');
          background-size: 100% 100%;
          // background: blue;
        }
      }
      .num-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 50px;
        color: #fff;
        border-bottom: 1px dashed #FF7D6F;
        .num-box-left {
          display: flex;
          align-items: center;
          img {
            width: 22px;
            height: 22px;
            margin-right: 5px;
          }
          p {
            color: #FFF5F3;
            font-size: 12px;
            font-weight: 600;
            span {
              font-size: 14px;
              margin-left: 5px;
            }
          }
        }
        img {
          width: 124px;
          height: 23px;
        }
      }
      .num-border {
        border-bottom: none;
      }
    }
    .notice-box {
      margin: 0 auto;
      width: 287px;
      background: url("https://img3.quanyou.com.cn/joy/group1/M00/10/04/rB4ChmJ4272AD54NAAAVyUuOMdU009.png");
      background-size: 100% 100%;
      >>> .van-notice-bar {
        padding 6px 10px;
        height: 24px;
        color: #FFFFFF;
        font-size: 9px;
        background: transparent;
      }
      .notice-swipe {
        height: 24px;
        line-height: 24px;
      }
    } 
  }
}
    
</style>